<template>
  <v-dialog
    v-model="active"
    persistent
    width="600"
    :scrollable="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="headline secondary" primary-title>
        <v-icon class="mr-3">share</v-icon> Deling av kartet
      </v-card-title>
      <v-card-text
        v-if="
          currentlyOpenedProject == null &&
            temporaryProjectID == null &&
            !loading
        "
      >
        <v-layout row class="pt-4">
          <v-text-field
            label="Gi kartet et passende navn"
            v-model="mapName"
            box
            single-line
            full-width
            maxlength="100"
          >
          </v-text-field>
        </v-layout>
      </v-card-text>
      <v-card-text
        v-if="(currentlyOpenedProject || temporaryProjectID) && !loading"
      >
        <v-layout column>
          <span class="heading"
            >Den øverste lenken gir tilgang til en lesbar versjon av kartet som
            ikke kan redigeres. Den nederste lenken gir tilgang til en
            redigerbar versjon av kartet. Kopier den lenken som passer til ditt
            formål og send til de du ønsker å dele kartet med.</span
          >
          <span class="heading pt-4" style="font-weight: bold"
            >Merknad: {{ shareText }}</span
          >

          <v-layout row class="pt-4">
            <v-text-field
              label="Lenke til lesbar versjon av kartet (kan ikke redigeres)"
              outline
              color="blue"
              ref="linkTextField"
              readonly
              v-model="projectLink"
            ></v-text-field>
            <v-btn
              class="mt-2"
              :color="copiedToClipBoard ? 'green' : 'blue'"
              dark
              depressed
              @click="
                copyLinkTextToClipBoard('linkTextField', 'copiedToClipBoard')
              "
            >
              {{ copiedToClipBoard ? "Kopiert" : "Kopier" }}
            </v-btn>
          </v-layout>

          <v-layout row v-if="saveIsEnabled">
            <v-text-field
              label="Lenke til redigerbar versjon av kartet"
              outline
              color="blue"
              ref="linkEditTextField"
              readonly
              v-model="projectEditLink"
            ></v-text-field>
            <v-btn
              class="mt-2"
              :color="editLinkCopiedToClipBoard ? 'green' : 'blue'"
              dark
              depressed
              @click="
                copyLinkTextToClipBoard(
                  'linkEditTextField',
                  'editLinkCopiedToClipBoard'
                )
              "
            >
              {{ editLinkCopiedToClipBoard ? "Kopiert" : "Kopier" }}
            </v-btn>
          </v-layout>
        </v-layout>
        <!-- <h4>Bygg inn kart (beta)</h4> -->
        <v-layout row v-if="saveIsEnabled">
          <v-text-field
            outline
            readonly
            ref="iframeTextArea"
            name="input-7-4"
            label="BETA: Bygg inn kart"
            :value="iframeLink"
          ></v-text-field>
          <v-btn
            class="mt-2"
            :color="buildInLinkCopiedToClipBoard ? 'green' : 'blue'"
            dark
            depressed
            @click="
              copyLinkTextToClipBoard(
                'iframeTextArea',
                'buildInLinkCopiedToClipBoard'
              )
            "
          >
            {{ buildInLinkCopiedToClipBoard ? "Kopiert" : "Kopier" }}
          </v-btn>
        </v-layout>
      </v-card-text>
      <v-card-text v-if="loading">
        <v-layout align-center column fill-height>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-layout>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn flat @click="emitDialogClosedEvent">
          Lukk
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="
            currentlyOpenedProject == null &&
              temporaryProjectID == null &&
              !loading
          "
          class="mt-2"
          :disabled="mapName == null || mapName == ''"
          color="primary"
          large
          depressed
          @click="saveTemporaryProject"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";

export default {
  name: "ShareProjectDialog",
  mixins: [MappingMixin],
  computed: {
    ...mapState([
      "currentlyOpenedProject",
      "userIsLoggedIn",
      "tools",
      "saveIsEnabled",
    ]),
    projectLink: function() {
      if (
        this.currentlyOpenedProject == null &&
        this.temporaryProjectID == null
      ) {
        return "";
      } else {
        return this.projectUrl;
      }
    },
    projectUrl: function() {
      return (
        window.location.origin +
        "/prosjekt/" +
        (this.currentlyOpenedProject === null
          ? this.temporaryProjectID.toLowerCase()
          : this.currentlyOpenedProject.attributes.GlobalID)
      );
    },
    projectEditLink: function() {
      if (
        this.currentlyOpenedProject == null &&
        this.temporaryProjectID == null
      ) {
        return "";
      } else {
        return (
          window.location.origin +
          "/prosjekt/" +
          (this.currentlyOpenedProject === null
            ? this.temporaryProjectID.toLowerCase()
            : this.currentlyOpenedProject.attributes.GlobalID) +
          "/" +
          this.editHashCode
        );
      }
    },
    iframeLink: function() {
      return (
        '<iframe src="' +
        this.projectUrl +
        '" width="800" height="650" frameborder="0" style="border:0;" aria-hidden="false" tabindex="0"></iframe>'
      );
    },
    active: function() {
      return this.tools.share.active;
    },

    projectIsPublic: function() {
      if (this.currentlyOpenedProject == null) {
        return "";
      } else {
        return this.currentlyOpenedProject.attributes.Offentlig === 1;
      }
    },
    editHashCode: function() {
      if (this.temporaryProjectID !== null) {
        return this.temporaryProjectID.toLowerCase().hashCode();
      }
      if (this.currentlyOpenedProject == null) {
        return this.currentlyOpenedProject.attributes.GlobalID.toLowerCase().hashCode();
      } else {
        return this.currentlyOpenedProject.attributes.GlobalID.toLowerCase().hashCode();
      }
    },
    projectIsTemporary: function() {
      if (this.currentlyOpenedProject == null) {
        return false;
      } else {
        return this.currentlyOpenedProject.attributes.midlertidig === 1;
      }
    },
    shareText: function() {
      if (this.temporaryProjectID || this.projectIsTemporary) {
        return "Vi gir ingen garantier for hvor lenge lenkene vil fortsette å fungere og lenkene bør derfor ikke brukes i rapporter eller lignende da de har en utløpsdato. Hvis du skal redigere kartet på et senere tidspunkt må du ta vare på lenken til den redigerbare versjonen.";
      }
      if (this.projectIsPublic) {
        return "Dette kartet er offentlig. Når du deler lenken med andre vil de kunne redigere kartet på samme måte som deg.";
      } else {
        return "Dette kartet er privat. Når du deler lenken med andre vil de kun ha lesetilgang til kartet.";
      }
    },
  },
  data: () => ({
    dialog: false,
    title: null,

    projectEditRole: "eier",
    mapName: null,
    saveInProgress: false,
    copiedToClipBoard: false,
    loading: false,
    editLinkCopiedToClipBoard: false,
    buildInLinkCopiedToClipBoard: false,
    temporaryProjectID: null,
    projectEditRoles: [
      {
        text: "Kun jeg skal kunne redigere kartet",
        value: "eier",
      },
      {
        text: "Alle skal kunne redigere kartet",
        value: "alle",
      },
    ],
  }),

  props: {
    saveProjectSettings: Boolean,
  },
  watch: {
    active: function(newVal) {
      if (newVal == true) {
        this.saveInProgress = false;
      }
    },
  },
  methods: {
    ...mapActions([
      "setSnack",
      "clearCurrentlyOpenedProject",
      "deactivateTool",
    ]),
    saveTemporaryProject() {
      this.loading = true;
      if (this.currentlyOpenedProject == null) {
        this.saveMap({
          attributes: {
            tittel: this.mapName,
            Offentlig: 1,
            redigering: "eier",
            midlertidig: 1,
          },
        }).then((result) => {
          this.temporaryProjectID = result.addFeatureResults[0].globalId;
          this.loading = false;
        });
      }
    },
    emitDialogClosedEvent() {
      this.title = null;
      this.copiedToClipBoard = false;
      this.editLinkCopiedToClipBoard = false;
      this.buildInLinkCopiedToClipBoard = false;
      this.temporaryProjectID = null;
      this.deactivateTool("share");
      this.$emit("close-dialog");
    },
    copyLinkTextToClipBoard(inputRef, isEditLinkInput) {
      this.selectLinkText(inputRef);
      document.execCommand("copy");
      this[isEditLinkInput] = true;

      // if (isEditLinkInput) {
      //   this.editLinkCopiedToClipBoard = true;
      // } else {
      //   this.copiedToClipBoard = true;
      // }
    },
    selectLinkText(inputRef) {
      this.$refs[inputRef].$el.querySelector("input").select();
    },
    saveProject() {
      this.saveInProgress = true;
      if (!this.saveProjectSettings) {
        this.clearCurrentlyOpenedProject();
      }

      this.saveMap({
        attributes: {
          tittel: this.title,
          Offentlig: this.projectIsPublic ? 1 : 0,
          redigering: this.projectEditRole,
        },
      })
        .then(() => {
          this.emitDialogClosedEvent();
          this.setSnack(
            this.saveProjectSettings ? "Kart lagret" : "Kart opprettet"
          );
        })
        .catch((error) => {
          console.error(error);
          this.setSnack("Lagring ikke gjennomført. Prøv igjen om litt.");
        });
    },
  },
};
</script>

<style scoped></style>
